<cv-multi-select
    [isLoading]="isLoading"
    [options]="descriptions"
    [(value)]="selectedIds"
    (valueChange)="selectedIdsChange.emit($event)"
    (opened)="isSelectorOpen = true"
    (closed)="onSelectorClose()"
    primaryKey="ContactStateID"
    label="ContactStateDescription"
></cv-multi-select>
